import styled from 'styled-components';
import { Flex } from '../../../components/blocks';

type Props = {
  nolink?: boolean;
};

const Img = styled.div<Props>`
  width: 100%;
  height: 240px;
  background: ${({ theme }) => theme.backgroundColors.default};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radii.m};
  padding: ${({ theme }) => theme.spaces.l};
  transition-duration: ${({ theme }) => theme.transitions.normal};
  border: 2px solid ${({ theme }) => theme.borderColors.default};

  ${({ theme }) =>
    theme.screen.min({
      maxHeight: '245px',
    })}

  &:hover {
    transform: ${({ nolink }) => (nolink ? 'inherit' : 'translateY(-2px)')};
    box-shadow: ${({ theme, nolink }) =>
      nolink ? 'inherit' : theme.boxShadow.base};
  }

  img {
    object-fit: contain;
  }
`;

const Contents = styled(Flex)`
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spaces.l};
  padding: ${({ theme }) => `${theme.spaces.l} ${theme.spaces.l} 0`};
`;

const Root = styled(Flex)`
  align-items: flex-start;
  flex-direction: column;

  ${({ theme }) =>
    theme.screen.sp({
      padding: `0 ${theme.spaces.l}`,
    })}
`;

export const ResourceBox = Object.assign(Root, { Img, Contents });
